function getBiCallback(key) {
  var _a, _b;
  const { children, _rcProps } = this.props;
  return ((_a = children == null ? void 0 : children.props.helpers) == null ? void 0 : _a[key]) || ((_b = _rcProps == null ? void 0 : _rcProps.helpers) == null ? void 0 : _b[key]);
}

export { getBiCallback };
//# sourceMappingURL=getBiCallbacks.js.map
